const DELEGATION_PREFIX = '/delegation/';
export const DELEGATION_VALIDATE_SELLER_CODE_URL = DELEGATION_PREFIX + 'validate-seller-code';
export const DELEGATION_CONNECT_URL = DELEGATION_PREFIX + 'connect';
export const DELEGATION_DISCONNECT_URL = DELEGATION_PREFIX + 'disconnect';
export const DELEGATION_GET_SELLERS_LIST_URL = DELEGATION_PREFIX + 'get-sellers';
export const DELEGATION_GET_BUYERS_LIST_URL = DELEGATION_PREFIX + 'get-buyers';
